<template>
  <div class="container">   
    <div class="column col-6 col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-8">
      <form class="form-horizontal">

      <div class="form-group">
        <div class="container">
        <div class="columns">
          <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="form-label">Client</label>
          </div>
          <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <searchClients v-on:selected="selectClient"></searchClients>
          </div>
        </div>
        </div>
      </div>

      <div class="form-group">
        <div class="container">
        <div class="columns">
          <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="form-label">Service Category</label>
        </div>
        <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <select v-model="agreement.visatype" class="form-select">
            <option value="" selected>Select</option>
            <option v-for="type in visatypes" :value="type.name">{{type.name}}</option>
          </select>
        </div>
        </div>
        </div>
      </div>

      <div class="form-group">
        <div class="container">
          <div class="columns">
            <div class="column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <label class="form-label">No GST</label>
            </div>
            <div class="column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
              <label class="form-checkbox">
                <input v-model="agreement.no_gst" type="checkbox">
                <i class="form-icon"></i>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="container">
          <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Cost</th>
                  <th>Quantity</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <select v-model="newItem.description" class="form-select" @change="selDesc">
                      <option value="">Select</option>
                      <option value="Standard Business Sponsorship">Standard Business Sponsorship</option>
                      <option value="482 Primary">482 Primary</option>
                      <option value="482 Nomination">482 Nomination</option>
                      <option value="Labour Market Testing (LMT)">Labour Market Testing (LMT)</option>
                      <option value="186 Primary">186 Primary</option>
                      <option value="186 Nomination">186 Nomination</option>
                      <option value="Skills Assessment">Skills Assessment</option>
                      <option value="Dependant O18">Dependant (Family Member over 18)</option>
                      <option value="Dependant U18">Dependant (Family Member under 18)</option>
                      <option value="Visitor Visa (subclass 600)">Visitor Visa (subclass 600)</option>
                      <option value="Onshore Partner Visa Application (sublass 820)">Onshore Partner Visa Application (sublass 820)</option>
                      <option value="Offshore Partner Visa Application (sublass 309)">Offshore Partner Visa Application (sublass 309)</option>
                      <option value="Australian Citizenship Application">Australian Citizenship Application</option>
                      <option value="189 Application">189 Application</option>
                      <option value="190 Application">190 Application</option>
                      <option v-if="otheritem" :value="otheritem">{{otheritem}}</option>
                      <option value="other">Other</option>
                    </select>
                  </td>
                  <td>
                    <div class="input-group">
                      <span class="input-group-addon">$</span>
                      <input v-model.number="newItem.cost" class="form-input" type="number">
                    </div>
                  </td>
                  <td><input v-model.number="newItem.quantity" class="form-input" type="number" value="1"></td>
                  <td><button @click.prevent="addItem" class="btn btn-primary btn-sm"><i class="icon icon-plus"></i></button></td>
                </tr>
                <tr v-for="(item, i) in agreement.items">
                  <td>{{item.description}}</td>
                  <td>${{c2d(item.cost)}}</td>
                  <td>{{item.quantity}}</td>
                  <td><button @click.prevent="delItem(i)" class="btn btn-sm"><i class="icon icon-minus"></i></button></td>
                </tr>
                <tr v-if="total">
                  <td></td>
                  <td>Total</td>
                  <td>${{c2d(total)}}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div v-if="withInvoice" class="col-12">
          <button @click.prevent="withInvoice = false" class="btn btn-primary">Remove Invoice</button>
        </div>
        <div v-else-if="newAgreement" class="col-9">
          <button @click.prevent="showSendModal = true" class="btn btn-primary">Send</button>
          <button @click.prevent="reset" class="btn btn-primary">Clear</button>
          <span class="label label-success">Agreement created</span>
          <span v-if="newAgreement && newAgreement.sent" class="label label-success">Agreement sent</span>
        </div>
        <div v-else class="col-9">
          <button @click.prevent="make" class="btn btn-primary" :class="{loading:isLoading}">Make</button>
          <button @click.prevent="withInvoice = true" class="btn btn-primary">Add Invoice</button>
          <button @click.prevent="reset" class="btn btn-primary">Clear</button>
        </div>
      </div>

      <span v-if="agreementErr" class="label label-error">{{agreementErr}}</span>
    </form>

    <!-- INVOICE-->
    <form v-show="withInvoice" class="form-horizontal">
      <div class="form-group">

          <div class="col-3">
            <label class="form-label">Items</label>
          </div>
          <div class="col-9">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Cost</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <select v-model="newInvItem.description" class="form-select" v-on:change="selItem">
                      <option value="">Select</option>
                      <option v-for="d in descriptions" :value="d">{{d}}</option>
                    </select>
                  </td>
                  <td>
                    <div class="input-group">
                      <span class="input-group-addon">$</span>
                      <input v-model.number="newInvItem.cost" class="form-input" type="number" step="0.01">
                    </div>
                  </td>
                  <td><button @click.prevent="addInvItem" class="btn btn-primary btn-sm"><i class="icon icon-plus"></i></button></td>
                </tr>
                <tr v-for="(item, i) in invoice.items">
                  <td>{{item.description}}</td>
                  <td>${{c2d(item.cost)}}</td>
                  <td><button @click.prevent="delInvItem(i)" class="btn btn-sm"><i class="icon icon-minus"></i></button></td>
                </tr>
                <tr v-if="totals[0]">
                  <td></td>
                  <td>GST</td>
                  <td>${{c2d(totals[0])}}</td>
                </tr>
                <tr v-if="totals[1]">
                  <td></td>
                  <td>Surcharge</td>
                  <td>${{c2d(totals[1])}}</td>
                </tr>
                <tr v-if="totals[2]">
                  <td></td>
                  <td>Total</td>
                  <td>${{c2d(totals[2])}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="form-group">
          <div class="col-3">
            <label class="form-label">Payment plan</label>
          </div>
          <div class="col-9 flexcol">
            <label class="form-switch">
              <input v-model="plan" type="checkbox">
              <i class="form-icon"></i>
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="col-5 col-ml-auto">
            <div v-if="plan" class="input-group">
              <span class="input-group-addon">Initial&nbsppayment&nbsp$</span>
              <input v-model.number="plan_initial" class="form-input" type="number" min="0" step="0.01">
            </div>
          </div>
          <div class="col-4">
            <div v-if="plan" class="input-group">
              <span class="input-group-addon">Monthly&nbsppayment&nbsp$</span>
              <input v-model.number="plan_monthly" class="form-input" type="number" min="0" step="0.01">
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="col-3"></div>
          <div v-if="newAgreement" class="col-9">
            <button @click.prevent="showSendModal = true" class="btn btn-primary">Send</button>
            <button @click.prevent="reset" class="btn btn-primary">Clear</button>
            <span v-if="newAgreement.sent" class="label label-success">Agreement and invoice sent</span>
            <span v-else class="label label-success">Agreement and invoice created</span>
          </div>
          <div v-else class="col-9">
            <button @click.prevent="make" class="btn btn-primary" :class="{loading:isLoading}">Make</button>
            <button @click.prevent="reset" class="btn btn-primary">Clear</button>
          </div>
        </div>

      <span v-if="invoiceErr" class="label label-error">{{invoiceErr}}</span>
    </form>
    <!-- END INVOICE-->

    <!-- OTHER ITEM MODAL -->
    <div class="modal" :class="{active: othermodal}">
      <div class="modal-overlay"></div>
      <div class="modal-container" style="width:64rem;">
        <div class="modal-body">
          <div class="content">
            <div class="form-group">
              <label class="form-label">Item description</label>
              <input v-model="otheritem" class="form-input">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click.prevent="othermodal = false; newItem.description = otheritem">Done</button>
        </div>
      </div>
    </div>
    <!-- END OTHER ITEM MODAL -->

    <!-- OTHER INVOICE ITEM MODAL -->
    <div class="modal" :class="{active: otherInvModal}">
      <div class="modal-overlay"></div>
      <div class="modal-container" style="width:64rem;">
        <div class="modal-body">
          <div class="content">
            <div class="form-group">
              <label class="form-label">Item description</label>
              <input v-model="newInvDesc" class="form-input">
            </div>
            <div class="form-group">
              <label class="form-checkbox">
                <input type="checkbox" v-model="newInvItem.surcharge">
                <i class="form-icon"></i> Surcharge
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click.prevent="addInvDesc">Done</button>
        </div>
      </div>
    </div>
    <!-- END OTHER INVOICE ITEM MODAL -->

    <sendModal :show="showSendModal"
               :agreement="newAgreement"
               :invoice="newInvoice"
               v-on:close="showSendModal = false"></sendModal>

  </div>
</div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import sendAgreementModal from '@/components/agreements/sendAgreementModal'
import searchClients from '@/components/users/searchClients'

export default {
  name: 'makeAgreement',
  mixins: [utils],
  components: {
    'sendModal': sendAgreementModal,
    'searchClients': searchClients
  },
  data () {
    return {
      client: null,
      visatypes: [],
      isLoading: false,
      success: false,
      othermodal: false,
      showSendModal: false,
      otheritem: '',
      withInvoice: false,
      // Agreement
      newAgreement: null, // newly made agreement returned from server
      agreementErr: null,
      agreement: {
        brand: '',
        email: '',
        name: '',
        business: '',
        phone: '',
        address: '',
        visatype: '',
        no_gst: false,
        items: []
      },
      newItem: {
        description: '',
        cost: 0,
        quantity: 1
      },
      // Invoice
      newInvoice: null, // newly made invoice returned from server
      invoiceErr: null,
      plan: false,
      plan_initial: 0,
      plan_monthly: 0,
      otherInvModal: false,
      invoice: {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      },
      newInvItem: {
        description: '',
        surcharge: false,
        cost: 0
      },
      newInvDesc: '',
      descriptions: utils.invoiceItems()
    }
  },
  created: function () {
    // Load visatypes
    axios.get('/api/allvisatypes').then(res => {
      if (res.status === 200) {
        this.visatypes = res.data
      }
    })
  },
  computed: {
    total: function () {
      return this.agreement.items.reduce((sum, i) => {
        return sum + i.cost * i.quantity
      }, 0)
    },
    totals: function () {
      // Calculate surcharge, GST and total
      let gst = 0
      let total = 0
      let surcharge = 0

      for (let i of this.invoice.items) {
        total += i.cost
        if (i.surcharge) {
          surcharge += i.cost
        } else if (!this.no_gst && i.cost > 0) { // Ignore discounts in GST
          gst += i.cost
        }
      }

      gst = parseInt(gst * 0.1)
      surcharge = parseInt(surcharge * 0.014)
      total = parseInt(total + surcharge + gst)

      return [gst, surcharge, total]
    }
  },
  methods: {
    reset: function () {
      this.success = false
      this.newAgreement = null
      this.agreementErr = null
      this.invoiceErr = null
      this.agreement = {
        email: '',
        name: '',
        business: '',
        phone: '',
        address: '',
        visatype: '',
        no_gst: false,
        items: []
      }
      this.invoice = {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      }
      this.newInvItem = {
        description: '',
        surcharge: false,
        cost: 0
      }
    },
    selectClient: function (user) {
      this.client = user
    },
    selDesc: function () {
      if (this.newItem.description === 'other') {
        this.othermodal = true
      }
    },
    addItem: function () {
      if (this.newItem.description.trim() === '') {
        return
      }
      this.newItem.cost = this.newItem.cost.toFixed(2) * 100 // $->c
      this.agreement.items.push(this.newItem)
      this.newItem = {
        description: '',
        cost: 0,
        quantity: 1
      }
    },
    delItem: function (i) {
      this.agreement.items.splice(i, 1)
    },
    // Invoice functions, mainly copied from makeInvoice
    c2d: function (c) {
      return (c / 100).toFixed(2)
    },
    selItem: function () {
      if (this.newInvItem.description === 'Other') {
        this.otherInvModal = true
      }
    },
    delInvItem: function (i) {
      this.invoice.items.splice(i, 1)
    },
    addInvDesc: function () {
      this.otherInvModal = false
      this.newInvDesc = this.newInvDesc.trim()
      if (this.newInvDesc === '') return
      this.descriptions.push(this.newInvDesc)
      this.newInvItem.description = this.newInvDesc
      this.newInvDesc = ''
    },
    addInvItem: function () {
      if (this.newInvItem.description.trim() === '') {
        return
      }
      this.newInvItem.cost *= 100 // $->c
      this.invoice.items.push(this.newInvItem)
      this.newInvItem = {
        description: '',
        surcharge: false,
        cost: 0
      }
    },
    make: function () {
      if (!this.client) return
      this.agreementErr = null
      this.invoiceErr = null

      // Check that there is at least one agreement item
      if (this.agreement.items.length === 0) {
        this.agreementErr = 'Agreement has no items'
        return
      }

      // Copy fields from the client brief into the agreement
      let a = this.agreement
      let u = this.client
      let p = u.profile
      a.user = u._id
      a.email = u.email
      a.name = p.firstname + ' ' + p.lastname
      a.business = p.business
      a.phone = p.phone
      a.corporate = p.corporate
      a.brand = p.brand || 'pl'

      // Make only the agreement
      if (!this.withInvoice) {
        this.isLoading = true
        axios.post('/api/agreements/new', this.agreement)
        .then(res => {
          if (res.status === 200) {
            this.newAgreement = res.data
            this.isLoading = false
            this.success = true
            this.$emit('new', this.newAgreement)
            utils.methods.delay(3000, () => { this.success = false })
          }
        }).catch(err => { console.log(err) })
        return
      }

      //
      // Make both agreement and invoice
      //

      if (this.invoice.items.length === 0) {
        this.invoiceErr = 'Invoice has no items'
        return
      }

      // Set the required invoice fields
      let totals = this.totals // [gst, surcharge, total]
      this.invoice.matter_desc = this.agreement.visatype
      this.invoice.gst = totals[0]
      this.invoice.surcharge = totals[1]
      this.invoice.total = totals[2]
      this.invoice.outstanding = totals[2]

      this.invoice.user = u._id
      this.invoice.firstname = p.firstname
      this.invoice.lastname = p.lastname
      this.invoice.business = p.corporate ? p.business : null
      this.invoice.brand = p.brand || 'pl'
      this.invoice.plan = this.plan
      if (this.plan) {
        this.invoice.initial = this.plan_initial * 100
        this.invoice.monthly = this.plan_monthly * 100
      }

      // Reference number
      if (p.corporate) {
        let bname = p.business.toUpperCase().replace(' &', '').split(' ')
        if (bname.length > 1) {
          this.invoice.ref = bname[0][0] + bname[1][0]
        } else {
          this.invoice.ref = bname[0][0] + (bname[0][1] || '_')
        }
      } else {
        this.invoice.ref = p.firstname[0] + (p.lastname[0] || '_')
      }

      axios.post('/api/agreements/newinv', {
        agreement: this.agreement,
        invoice: this.invoice
      }).then(res => {
        if (res.status === 200) {
          this.newAgreement = res.data.agreement
          this.newInvoice = res.data.invoice
          this.isLoading = false
          this.success = true
          this.$emit('new', this.newAgreement)
          utils.methods.delay(3000, () => { this.success = false })
        }
      }).catch(err => { console.log(err) })
    }
  }
}
</script>

<style scoped>
.agreement-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.agreement-item select {
  width: auto;
}
.agreement-item input {
  width: auto;
}
.flexcol {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// makeAgreement.vue?e003b4ec